import React from 'react';
import { decl } from '@yandex-lego/i-bem-react';
import "./../../textinput/textinput.react.js";
import "./../../../desktop.blocks/textinput/textinput.react.js";
import "./../../textinput/_theme/textinput_theme_websearch.react.js";
import _textinput_hasClear_yes from "./../../textinput/_has-clear/textinput_has-clear_yes.react.js";

var TextInput = _textinput_hasClear_yes.applyDecls();

import "./../../textinput/_theme/textinput_theme_websearch.css";
import "./../../textinput/__clear/textinput__clear.react.js";
import "./../../textinput/__clear/textinput__clear.css";
import "./../../../desktop.blocks/textinput/__clear/textinput__clear.css";
import "./../../textinput/__icon/textinput__icon.react.js";
import "./../../textinput/__icon/textinput__icon.css";


export default decl({
    block: 'search2',
    elem: 'input',
    content: function content(props) {
        return props.input || React.createElement(TextInput, props);
    }
}, {
    isInput: function isInput(child) {
        return child && typeof child.type === 'function' && child.type.displayName === 'search2__input';
    }
});